const UNIQUE_KEY_PROP = "__dwp_unique_key__";
const KEY_PREFIX = "__dwp__" + Date.now() + "_";
let uid = 0;

const isObject = (val) => val !== null && typeof val === "object";

const genUniqueKey = (obj) => {
  if (isObject(obj)) {
    if (UNIQUE_KEY_PROP in obj) {
      return obj[UNIQUE_KEY_PROP];
    }
    const value = KEY_PREFIX + uid++;
    Object.defineProperty(obj, UNIQUE_KEY_PROP, { value });
    return value;
  }
  return obj;
};

export default genUniqueKey;
